import React, { useContext, useEffect } from 'react';
import AccordionContext from './AccordionCtx';

const AccordionListener = () => {
  const [
    { openItems, onChange },
    { getAccordionItems }] = useContext(AccordionContext);

  useEffect(() => {
    if (onChange) {
      onChange(getAccordionItems());
    }
  }, [openItems]);

  return null;
};

export default AccordionListener;
